import React from "react";
import { useLocation } from "react-router-dom";
import { VEHICLE_IMAGES } from "../../../Utils/Vehicleimg";

const { car, truck, auto, bike } = VEHICLE_IMAGES;

const vehicleData = {
  "Two Wheeler": {
    title: "Two Wheelers from Packky",
    name: "2 Wheeler",
    image: bike,
    weight: "20 kg",
    price: "₹48",
    height: "40cm",
    width: "40cm",
    description:
      "Best for small parcels, documents, food packages, and lightweight deliveries. Base fare is inclusive of 1.0 km distance & 25 minutes of order time.",
  },
  "Three Wheeler": {
    title: "Three Wheelers from Packky",
    name: "3 Wheeler",
    image: auto,
    weight: "500 kg",
    price: "₹180",
    height: "5 ft",
    width: "4.5 ft",
    description:
      "Best for medium goods, cartons, grocery supplies, and business deliveries. Pricing may vary based on distance, locality, waiting time, toll, parking, and other applicable charges.",
  },
  "Four Wheeler": {
    title: "Four Wheelers from Packky",
    name: "4 Wheeler",
    image: car,
    weight: "750 kg",
    price: "₹250",
    height: "5.5 ft",
    width: "5 ft",
    description:
      "Best for larger packages, bulk movement, fragile items, and commercial logistics. Fare may vary depending on route, pickup/drop location, and additional charges.",
  },
  "Mini Truck": {
    title: "Mini Trucks from Packky",
    name: "Mini Truck",
    image: truck,
    weight: "1000 kg",
    price: "₹350",
    height: "6 ft",
    width: "5.5 ft",
    description:
      "Best for heavy goods, shifting items, large inventory movement, and business logistics. Extra charges such as road tax, parking, tolls, and waiting may apply.",
  },
};

const Porter = () => {
  const location = useLocation();

  const normalizeVehicleName = (vehicle = "") => {
    const value = String(vehicle).trim().toLowerCase();

    if (
      value.includes("two") ||
      value.includes("2 wheeler") ||
      value === "2" ||
      value.includes("bike")
    ) {
      return "Two Wheeler";
    }

    if (
      value.includes("three") ||
      value.includes("3 wheeler") ||
      value === "3" ||
      value.includes("auto")
    ) {
      return "Three Wheeler";
    }

    if (
      value.includes("four") ||
      value.includes("4 wheeler") ||
      value === "4" ||
      value.includes("eeco") ||
      value.includes("car")
    ) {
      return "Four Wheeler";
    }

    if (
      value.includes("mini") ||
      value.includes("truck") ||
      value.includes("pickup")
    ) {
      return "Mini Truck";
    }

    return "Two Wheeler";
  };

  const selectedVehicle = normalizeVehicleName(
    location.state?.vehicle || sessionStorage.getItem("selectedVehicle") || "",
  );

  const selectedData =
    vehicleData[selectedVehicle] || vehicleData["Two Wheeler"];

  return (
    <section className="w-full bg-[#edeff1] px-4 py-16">
      <div className="mx-auto max-w-5xl">
        <div className="mb-6 px-2 text-center sm:mb-8">
          <span className="mb-3 inline-flex rounded-full bg-blue-50 px-3 py-2 text-[10px] font-semibold uppercase tracking-wide text-blue-700 sm:px-4 sm:text-xs">
            Selected Vehicle
          </span>

          <h2 className="text-xl font-bold text-slate-900 sm:text-2xl md:text-3xl">
            {selectedData.title}
          </h2>

          <p className="mx-auto mt-3 max-w-[560px] text-sm leading-6 text-slate-500 sm:text-[15px]">
            Vehicle details, capacity, and estimated starting fare based on your
            current selection.
          </p>
        </div>

        <div className="mx-auto grid max-w-4xl grid-cols-1 items-center gap-6 overflow-hidden rounded-[24px] border border-slate-200 bg-white p-5 shadow-[0_18px_45px_rgba(15,23,42,0.10)] sm:p-6 md:grid-cols-2 md:gap-8 md:p-10">
          {/* LEFT IMAGE */}
          <div className="flex justify-center">
            <div className="relative flex h-[220px] w-full max-w-[280px] items-center justify-center rounded-[24px] bg-gradient-to-br from-blue-50 to-slate-100 p-5 sm:h-[250px] sm:max-w-[300px] sm:p-6">
              <div className="absolute -left-2 top-1/2 -translate-y-1/2 rounded-full bg-white px-2 py-1 text-xs font-bold text-slate-400 shadow-sm sm:px-3 sm:text-sm">
                {selectedData.height}
              </div>

              <div className="absolute left-1/2 top-3 -translate-x-1/2 rounded-full bg-white px-2 py-1 text-xs font-bold text-slate-400 shadow-sm sm:px-3 sm:text-sm">
                {selectedData.width}
              </div>

              <img
                src={selectedData.image}
                alt={selectedData.name}
                className="max-h-[150px] w-full object-contain sm:max-h-[180px]"
              />
            </div>
          </div>

          {/* RIGHT CONTENT */}
          <div className="text-center md:text-left">
            <div className="mb-3 inline-flex rounded-full bg-blue-600 px-4 py-2 text-xs font-semibold uppercase tracking-wide text-white">
              {selectedVehicle}
            </div>

            <h3 className="text-xl font-bold text-slate-900 sm:text-2xl">
              {selectedData.name}
            </h3>

            <div className="mt-3 inline-flex items-center rounded-xl bg-blue-50 px-3 py-2 text-sm font-semibold text-slate-700">
              ⚖ {selectedData.weight}
            </div>

            <p className="mt-4 text-lg font-bold text-slate-800 sm:text-xl">
              Starting From{" "}
              <span className="text-blue-700">{selectedData.price}</span>
            </p>

            <p className="mt-3 text-sm leading-6 text-slate-600 sm:leading-7">
              {selectedData.description}
            </p>

            <button className="mt-5 border-b border-dotted border-blue-600 text-sm font-semibold text-blue-600 transition hover:text-blue-700">
              Know More
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Porter;
